import { render, staticRenderFns } from "./HighCost.vue?vue&type=template&id=38733b9d&"
import script from "./HighCost.vue?vue&type=script&lang=ts&"
export * from "./HighCost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports